import { doGet, doGetOld, doPatchOld, doPostOld, pathWithPageAndFilters } from './base'
import { ACCOUNT_STATUS_ACTIONS } from './base'

export const getUsers = async (
  page: ApiPage,
  filters: ApiFilter[] = [],
  pageSize: number = 10
): Promise<UsersListResponse> => {
  return await doGetOld(pathWithPageAndFilters('/api/users/users', filters, page, pageSize))
}

export const getUser = async (id: string): Promise<UserResponse | ApiError> => {
  return await doGetOld(`/api/users/users/${id}`)
}

export const updateUser = async (id: string, data: UpdateUserRequest): Promise<UpdateUserResponse> => {
  return await doPatchOld(`/api/users/users/${id}`, data)
}

const changeUserStatus = async (id: string, action: ACCOUNT_STATUS_ACTIONS): Promise<UpdateUserResponse> => {
  return await doPatchOld(`/api/users/users/${id}/${action}`)
}

export const activateUser = async (id: string): Promise<UpdateUserResponse> => {
  return await changeUserStatus(id, ACCOUNT_STATUS_ACTIONS.ACTIVATE)
}

export const deactivateUser = async (id: string): Promise<UpdateUserResponse> => {
  return await changeUserStatus(id, ACCOUNT_STATUS_ACTIONS.DEACTIVATE)
}

export const getPasskeys = async (
  id: string,
  page: ApiPage,
  filters: ApiFilter[] = [],
  pageSize: number = 10
): Promise<PasskeysListResponse> => {
  return await doGetOld(pathWithPageAndFilters(`/api/users/users/${id}/passkeys`, filters, page, pageSize))
}

export const exportEmailHistory = async (): Promise<ApiNoContentResponse> => {
  return await doPostOld(`/api/users/users/export_email_history`)
}

export const createUser = async (data: CreateUserRequest): Promise<CreateUserResponse> => {
  return await doPostOld(`/api/users/users/invite`, data)
}

export const resendInvite = async (id: string): Promise<ApiNoContentResponse> => {
  return await doPostOld(`/api/users/users/${id}/send_invite`)
}

export const exportUsers = async (filters: ApiFilter[]): Promise<ApiError> => {
  return await doGetOld(pathWithPageAndFilters(`/api/users/users/export`, filters))
}

export const getUserOptions = async (): Promise<ApiResponse<{ users: { name: string; id: string }[] }>> => {
  return await doGet(`/api/users/users/all`)
}

export default {
  getUsers,
  getUser,
  updateUser,
  activateUser,
  deactivateUser,
  getPasskeys,
  exportEmailHistory,
  resendInvite,
  exportUsers,
  getUserOptions
}
